import React, { useMemo, useRef } from 'react';
import { Tag } from 'shared/assets/icons';
import { TagContextMenu } from 'shared/components/connected/tag-context-menu';
import { Icon } from 'shared/components/ui/icon';
import {
  SortableContainer,
  SortableContainerProps,
} from 'shared/components/ui/sortable-container';
import { useContextMenuState } from 'shared/hooks/use-context-menu-state';
import { Paths } from 'shared/routes';
import { DraggableOptions } from 'shared/types/draggable-types';
import { Tag as TagType } from 'shared/types/tag';
import { replaceUrlParams } from 'shared/utils/replace-url-params';
import { useTheme } from 'styled-components';

import * as Styled from './tag-side-menu-item.style';

export type TagSideMenuItemProps = {
  tag: TagType;
  currentPath: string;
  isMoving?: boolean;
  hasDnd?: boolean;
};

export const TagSideMenuItem: React.FC<TagSideMenuItemProps> = ({
  tag,
  currentPath,
  isMoving,
  hasDnd,
}) => {
  const theme = useTheme();
  const containerRef = useRef<HTMLAnchorElement>(null);

  const { position, open, close } = useContextMenuState({
    disabled: theme.isMobile,
  });

  const url = replaceUrlParams(Paths.TagDetail, { id: tag.id });
  const isActive = !!currentPath && currentPath.includes(url);

  const Container = hasDnd ? SortableContainer : React.Fragment;

  const containerProps = useMemo(
    () =>
      (hasDnd
        ? { id: tag.id, type: DraggableOptions.Tag }
        : {}) as SortableContainerProps,
    [hasDnd, tag.id],
  );

  return (
    <Container {...containerProps}>
      <Styled.Link
        to={url}
        $active={isActive}
        $isMoving={!!isMoving}
        ref={containerRef}
        onContextMenu={open}
      >
        <Styled.IconContainer $color={tag.color}>
          <Icon icon={Tag} />
        </Styled.IconContainer>
        <Styled.Title>{tag.name}</Styled.Title>

        {!!position && (
          <TagContextMenu id={tag.id} onClose={close} location={position} />
        )}
      </Styled.Link>
    </Container>
  );
};
